// Public interface for PDF reader - only exports tested methods

import type { AsyncSequence } from "@pdfking/tfunc"

import type { SpatialRectangle } from "../geometry/SpatialRectangle"
import type { Pixel } from "../units/Units"

export type PDFReader = {
  page_count(): Promise<number>
  rasterize(
    page: number,
    options?: { scale: number; max_size?: number }
  ): Promise<{
    stream: AsyncSequence<Blob>
    size: SpatialRectangle<Pixel>
  }>
  extract_page_as_pdf(page: number): Promise<{
    stream: AsyncSequence<Blob>
    trim_box: SpatialRectangle<Pixel>
    media_box: SpatialRectangle<Pixel>
  }>
  close(): Promise<void>
}
